import common from "../common";
import md5 from "md5";

export default class SaveData extends PIXI.Container {
    constructor()
    {
        super();

        this.SAVE_NAME = "superherogirls";
        this.SAVE_SEED = "x5k0Eo6R177mUkb";

        this.template = {
            topScores:[
                {score:0, stars:0},
                {score:0, stars:0},
                {score:0, stars:0}
            ]
        };

        this.data = null;

        this.init();
    }

    init()
    {
        this.load();
    }

    load()
    {
        this.data = {};
        for(var i in this.template)
        {
            this.data[i] = this.template[i];
        }

        
        if(window.localStorage[this.SAVE_NAME])
        {
            var data = window.localStorage[this.SAVE_NAME];
            this.loadData(data);
        }
        this.save();
    }

    loadData(dataString)
    {
        var data = JSON.parse(dataString);

        var hash = data.hash;
        delete data.hash;

        if(hash === md5(JSON.stringify(data) + this.SAVE_SEED) )
        {
            for(var i in data)
            {
                this.data[i] = data[i];
            }
            console.log('DATA LOADED SUCCESSFULLY');
        }
        else
        {
            console.log('DATA DOES NOT MATCH HASH - DATA HAS BEEN RESET');
        }
    }

    save()
    {   
        window.localStorage[this.SAVE_NAME] = this.saveData();
    }

    saveData()
    {
        var data = {};
        for(var i in this.data)
        {
            data[i] = this.data[i];
        }
        data.hash = md5(JSON.stringify(data) + this.SAVE_SEED);

        return JSON.stringify(data);
    }

    clear()
    {
        this.data = {};
        for(var i in this.template)
        {
            this.data[i] = this.template[i];
        }
        this.save();
    }

    getTopScore(level)
    {
        return this.data.topScores[level];
    }

    saveTopScore(level, score, stars)
    {
        this.data.topScores[level].score = score;
        this.data.topScores[level].stars = stars;
        this.save();
        return this.data.topScores;
    }
}